import { createFileRoute, Outlet } from '@tanstack/react-router'

// Access is enforced by the central route guard in __root.tsx (voice:admin)
export const Route = createFileRoute('/admin/voices')({
  component: Outlet,
})
